<template>
  <div class="tw:size-full">
    <div
      class="tw:bg-gradient-to-br tw:from-default-100 tw:to-default-200 tw:rounded-md tw:relative tw:h-full tw:w-full tw:overflow-hidden"
    >
      <div
        class="tw:bg-gradient-to-r tw:from-transparent tw:via-branding-100 tw:via-60% tw:to-transparent reflex-animation tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:top-0"
      />
    </div>
  </div>
</template>

<style scoped>
.reflex-animation {
  animation: infinite reflex 2s;
}

@keyframes reflex {
  from {
    transform: translate(-100%);
  }
  to {
    transform: translate(100%);
  }
}
</style>
